export const s = {
    /* ============================
       PAGE
    ============================ */

    page:
        "min-h-screen bg-[#F4F1E8] text-[#39433C] font-['Hanken_Grotesk']",

    wrap:
        "max-w-[1080px] mx-auto px-7",
    /* ============================
       PROGRESS BAR
    ============================ */

    progressContainer:
        "fixed top-0 left-0 right-0 h-[3px] bg-[#E3E0D8] z-[9999] overflow-hidden",

    progressBar:
        "h-full bg-[#147A59] transition-[width] duration-150 ease-linear",

    /* ============================
       FLOATING HEADER
    ============================ */

    header:
        "fixed top-0 left-0 right-0 z-[999] h-[56px] sm:h-[60px] md:h-[64px] bg-[#F4F1E8]/95 backdrop-blur-xl border-b border-[#DDD6CA] transition-all duration-300 -translate-y-full opacity-0",

    headerVisible:
        "translate-y-0 opacity-100",

    headerInner:
        "w-full mx-auto h-full px-4 sm:px-6 lg:px-7 flex items-center justify-between",

    headerLeft:
        "flex items-center gap-2 sm:gap-3",

    mark:
        "w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 rounded-[7px] sm:rounded-[8px] bg-[#13211B] text-white flex items-center justify-center font-['Fraunces'] text-[13px] sm:text-[14px] md:text-[15px] font-semibold shrink-0",

    topButton:
        "inline-flex items-center gap-1 sm:gap-2 font-['DM_Mono'] text-[10px] sm:text-[11px] font-medium uppercase tracking-[0.08em] text-[#147A59] hover:text-[#0F5B44] transition-colors shrink-0",


    headerLogo:
        "w-6 h-6 shrink-0",

    barTitle:
        "font-['Fraunces'] text-[14px] font-semibold text-[#13211B]",

    barDivider:
        "text-[#9BA295] mx-1",

    barSubtitle:
        "font-['DM_Mono'] text-[11px] uppercase tracking-[0.08em] text-[#6E756A]",
    /* ============================
       DOCUMENT HEADER
    ============================ */

    docHeader:
        "pt-[84px] pb-10 border-b border-[#E3E0D8]",

    eyebrow:
        "inline-flex items-center gap-3 mb-7",

    brandMark:
        "w-[30px] h-[30px] shrink-0",

    brandName:
        "font-['DM_Mono'] text-[12px] font-medium uppercase tracking-[0.12em] text-[#13211B]",

    logo:
        "w-[30px] h-[30px] rounded-[9px] bg-[#13211B] text-[#F4F1E8] flex items-center justify-center font-['Fraunces'] font-semibold text-[17px]",

    logoText:
        "font-['DM_Mono'] text-[12px] font-medium tracking-[0.12em] uppercase text-[#13211B]",

    title:
        "font-['Fraunces'] font-medium text-[clamp(38px,6vw,60px)] leading-[1.02] tracking-[-0.015em] text-[#13211B] max-w-[12ch] [font-variation-settings:'opsz'_144]",

    lede:
        "mt-5 max-w-[42rem] text-[18px] leading-[1.7] text-[#39433C]",

    /* ============================
       META
    ============================ */

    heroGrid:
        "mt-[30px]",

    heroLeft:
        "",

    heroRight:
        "flex justify-end",

    meta:
        "flex flex-wrap items-center gap-x-[26px] gap-y-[10px] mt-[30px]",

    metaItem:
        "flex flex-col gap-[3px]",

    metaLabel:
        "font-['Fraunces'] text-[10.5px] font-medium tracking-[0.08em] uppercase text-[#9BA295]",

    metaValue:
        "text-[14px] font-medium text-[#13211B]",

    /* ============================
       DISCLOSURE
    ============================ */

    disclosure:
        "mt-[30px] flex items-start gap-4 max-w-[42rem] rounded-[12px] border border-[#A8D8C8] bg-[#E8F5F0] px-5 py-4",

    disclosureIcon:
        "w-5 h-5 shrink-0 mt-[2px] text-[#147A59]",

    disclosureText:
        "text-[14.5px] leading-[1.6] text-[#0D5C42]",

    disclosureStrong:
        "font-semibold text-[#0D5C42]",

    /* ============================
       CONTENT
    ============================ */

    contentSection:
        "py-20",

    contentWrapper:
        "max-w-[1080px] mx-auto px-7 grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-14",


    /* ============================
       TABLE OF CONTENTS
    ============================ */

    sidebar: "hidden lg:block",

    sidebarCard: "sticky top-[90px]",
    sidebarTitle: "font-['DM_Mono'] text-[10.5px] uppercase tracking-[0.1em] font-medium text-[#A3AAA0] mb-[14px] pl-[14px]",

    sidebarLinks: "flex flex-col",

    sidebarLink: "block w-full text-left text-[13.5px] leading-[1.4] py-[6px] pl-[14px] no-underline border-l-2 border-[#E3E0D8] text-[#6B736F] transition-all duration-200 hover:text-[#147A59]",

    sidebarLinkActive: "!text-[#147A59] !border-l-[#147A59] font-semibold",

    sidebarNumber: "hidden",

    tocToggle: "lg:hidden w-full mb-4 flex items-center justify-between rounded-xl border border-[#E3E0D8] bg-white px-5 py-3 text-[14px] font-semibold text-[#13211B]",

    mobileSidebar: "lg:hidden rounded-xl border border-[#E3E0D8] bg-white overflow-hidden",

    mobileSidebarOpen: "block",

    mobileSidebarClosed: "hidden",
    /* ============================
     ARTICLE
  ============================ */

    article:
        "max-w-[760px]",

    section:
        "pt-[18px] mb-[46px] scroll-mt-[84px] first:pt-0",

    sectionHeader:
        "flex items-baseline gap-[14px] mb-[16px]",

    sectionNumber:
        "w-[1.6em] shrink-0 font-['Fraunces'] text-[18px] font-medium leading-[1.3] text-[#147A59]",

    sectionTitle:
        "text-[22px] font-semibold leading-[1.25] tracking-[-0.01em] text-[#13211B]",

    sectionContent:
        "space-y-[15px]",

    paragraph:
        "text-[15px] leading-[1.8] text-[#4D5A54]",

    definitionList:
        "space-y-8",

    definitionItem:
        "space-y-2",

    definitionTerm:
        "text-[18px] font-['Fraunces'] font-semibold text-[#13211B]",

    definitionDescription:
        "text-[15px] leading-[1.9] text-[#4D5A54]",

    cleanList:
        "mt-5 space-y-4",

    cleanListItem:
        "relative pl-7 text-[15px] leading-[1.9] text-[#4D5A54] before:absolute before:left-[4px] before:top-[12px] before:w-[7px] before:h-[7px] before:rounded-full before:bg-[#8FD8C8]",
    subHeading:
        "mt-8 mb-4 text-[18px] font-medium text-[#13211B]",

    group:
        "mt-10",

    groupTitle:
        "mb-5 font-['DM_Mono'] text-[13px] font-bold uppercase tracking-[0.06em] text-[#13211B]",
    hipaaCard:
        "mt-8 bg-[#E8F5F0] border-l-[3px] border-[#A8D8C8] rounded-r-[18px] pl-6 pr-6 py-6",
    hipaaTitle:
        "mb-5 text-[18px] font-semibold text-[#13211B]",

    /* ============================
       AGREEMENT
    ============================ */


    affirm:
        "mt-8 rounded-[20px] bg-[#13211B] px-7 py-8",

    affirmTitle:
        "font-['Fraunces'] text-[18px] font-semibold leading-[1.5] text-[#F4F1E8] mb-5",

    affirmDesc:
        "text-[16px] leading-8 text-white/65",

    /* ============================
       CONTACT
    ============================ */

    contactCard:
        "mt-8 rounded-[20px] border border-[#DDD6CA] bg-white px-7 py-8",


    org:
        "text-[18px] font-semibold text-[#13211B] mb-5",

    contactRow:
        "text-[17px] leading-9 text-[#4D5A54]",
    /* ============================
       FOOTER
    ============================ */


    footer:
        "mt-20 border-t border-[#DDD6CA] bg-white",

    footerInner:
        "max-w-[1080px] mx-auto px-7 py-11 flex flex-wrap justify-between gap-y-8 gap-x-16",

    footerBrand:
        "max-w-[290px]",

    footerLogo:
        "w-[30px] h-[30px] mb-[14px]",

    footerSub:
        "text-[13px] leading-[1.6] text-[#A3AAA0] max-w-[36ch]",

    footerColumn:
        "min-w-[170px]",

    footerHeading:
        "font-['DM_Mono'] text-[10.5px] uppercase tracking-[0.1em] text-[#A3AAA0] font-medium mb-[14px]",

    footerLinks:
        "flex flex-col",

    footerLink:
        "py-[4px] text-[14px] text-[#6B736F] transition-colors duration-200 hover:text-[#13211B]",

    footerBottom:
        "max-w-[1080px] mx-auto border-t border-[#DDD6CA] px-7 py-[18px] flex flex-wrap items-center justify-between gap-x-5 gap-y-2",

    footerCopy:
        "text-[12.5px] text-[#A3AAA0]",

    footerUpdated:
        "text-[12.5px] text-[#A3AAA0]",
    /* ============================
       BACK TO TOP
    ============================ */


    backToTop:
        "fixed bottom-6 right-6 z-50 w-[44px] h-[44px] rounded-full bg-[#13211B] text-[#F4F1E8] flex items-center justify-center shadow-lg opacity-0 pointer-events-none translate-y-2 scale-90 transition-all duration-300 hover:bg-[#147A59]",

    backToTopVisible:
        "opacity-100 pointer-events-auto translate-y-0 scale-100",

    /* ============================
       REVEAL
    ============================ */

    reveal:
        "opacity-0 translate-y-8 transition-all duration-700",

    revealVisible:
        "opacity-100 translate-y-0",

    revealDelay1:
        "delay-100",

    revealDelay2:
        "delay-200",

    revealDelay3:
        "delay-300",

    revealDelay4:
        "delay-[400ms]",

    /* ============================
       UTILITIES
    ============================ */

    mobileOnly:
        "block lg:hidden",

    desktopOnly:
        "hidden lg:block",

    divider:
        "h-px bg-[#E3E0D8] my-10",

    badge:
        "inline-flex items-center rounded-full bg-[#E8F5F0] px-4 py-2 text-[12px] font-semibold text-[#1D9E75]",

    sectionSpacing:
        "space-y-10",

    card:
        "rounded-[22px] border border-[#E3E0D8] bg-white p-8 shadow-sm",

    cardTitle:
        "font-['Fraunces'] text-[26px] text-[#13211B] mb-5",

    cardText:
        "text-[15px] leading-7 text-[#6B7E76]",

    link:
        "text-[#1D9E75] hover:underline",

    list:
        "list-disc pl-6 space-y-3 text-[#51615A] leading-7",

    note:
        "rounded-xl border border-[#E8F5F0] bg-[#F8FCFA] p-5 text-[14px] leading-7 text-[#4B5D56]",
};